// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\locations\\\\LocationInfo\\\\LocationInfo.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\locations\\LocationInfo\\LocationInfo.tsx");
  import.meta.hot.lastModified = "1757171103328.2522";
}
// REMIX HMR END

import { SectionHeader } from "~/components/shared/SectionHeader";
export function LocationInfo({
  data
}) {
  return <section className="w-full bg-white py-12 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 lg:px-14">
        <SectionHeader eyebrow="ABOUT" title={data.title} />

        <div className="my-12 lg:my-16">
          <p className="text-base lg:text-lg text-neutral-900 leading-relaxed max-w-5xl">
            {data.description}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {data.stats.map((stat, index) => <div key={index} className="border border-body-80 rounded-[999px] px-6 lg:px-8 py-6 lg:py-12 text-center flex justify-center items-center gap-[12px]">
              <div className="text-stat-number text-neutral-900">
                {stat.number}
              </div>
              <div className="text-stat-label text-neutral-600 whitespace-pre-line">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
_c = LocationInfo;
var _c;
$RefreshReg$(_c, "LocationInfo");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;